import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "exchange-table-widget" }
const _hoisted_2 = { class: "exchange-table" }
const _hoisted_3 = { class: "devise-col" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "code-col" }
const _hoisted_7 = { class: "achat-col" }
const _hoisted_8 = { class: "vente-col" }

import { ref, onMounted, computed } from "vue";
import { displayService } from '@/_services';


const __default__ = {
  name: "ExchangeTable",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    headerColor: {},
    textColor: {},
    header: {}
  },
  setup(__props: any) {

const props = __props;

const rates = ref<any[]>([]);

const codeToFlag = {
  USD: 'us',
  EUR: 'eu',
  GBP: 'gb',
  JPY: 'jpy',
  CAD: 'ca',
  CHF: 'ch',
  AED: 'aed',
  SAR: 'sa',
  QAR: 'qa',
  KWD: 'kw',
  BHD: 'bh',
  LYD: 'lyd',
  CNY: 'cny',
};

onMounted(async () => {
  try {
    const response = await displayService.getExchangeData();
    const changes = response.changes || [];
    const updatedRates = await Promise.all(
      changes.map(async (item: any) => {
        let flagSrc = '';
        try {
          const code = String(item.code);
          const flagFile = (codeToFlag as Record<string, string>)[code] || code.toLowerCase();
          const flagModule = await import(`@/assets/images/flags/${flagFile}.svg`);
          flagSrc = flagModule.default;
        } catch (error) {
          flagSrc = '';
        }
        return { ...item, flagSrc };
      })
    );
    rates.value = updatedRates;
  } catch (err) {
    console.error("Error loading exchange data:", err);
  }
});

const headers = computed(() => {
  if (
    props.header &&
    Array.isArray(props.header) &&
    props.header.length > 0 &&
    !(props.header.length === 1 && props.header[0].text === "")
  ) {
    return props.header.map((h) => h.text);
  }
  return ["DEVISE", "CODE", "UNITÉ", "ACHAT", "VENTE"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", {
          style: _normalizeStyle({ color: _ctx.headerColor })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value, (header, index) => {
            return (_openBlock(), _createElementBlock("th", {
              key: index,
              class: _normalizeClass({ 'first-header': index === 0, 'other-header': index > 0 })
            }, _toDisplayString(header), 3))
          }), 128))
        ], 4)
      ]),
      _createElementVNode("tbody", {
        style: _normalizeStyle({ color: _ctx.textColor })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rates.value, (rate, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass({ 'even-row': index % 2 === 1 })
          }, [
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (rate.flagSrc)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: rate.flagSrc,
                      class: "flag-img",
                      alt: rate.devise
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("td", _hoisted_6, _toDisplayString(rate.code), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(rate.buy.toFixed(3)), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(rate.sell.toFixed(3)), 1)
          ], 2))
        }), 128))
      ], 4)
    ])
  ]))
}
}

})